"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SheetPreview;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const previewRows_1 = require("./previewRows");
const headerStyle = {
    border: "1px solid #dee2e6",
    padding: "3px 6px",
    background: "#f1f3f5",
    fontWeight: 500,
    fontSize: 12,
    color: "#495057",
    verticalAlign: "bottom",
};
const derivedStyle = {
    border: "1px solid #dee2e6",
    padding: "4px 6px",
    fontSize: 12,
    background: "#f8f9fa",
    color: "#6c757d",
    verticalAlign: "top",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
};
const inputStyle = {
    border: "none",
    outline: "none",
    padding: "4px 6px",
    fontSize: 12,
    width: "100%",
    background: "transparent",
    resize: "none",
    display: "block",
    fontFamily: "inherit",
    lineHeight: 1.35,
};
function Cell({ cell, onChange }) {
    if (!cell.field && !cell.item)
        return (react_1.default.createElement("td", { style: derivedStyle, title: cell.hint || undefined }, cell.value || " "));
    const shared = {
        style: { ...inputStyle, textAlign: cell.numeric ? "right" : "left" },
        value: cell.value,
        onChange: (event) => onChange(event.target.value),
    };
    return (react_1.default.createElement("td", { style: {
            border: "1px solid #dee2e6",
            padding: 0,
            verticalAlign: "top",
        } }, cell.multiline ? (
    // Opis i „co wysłano” bywają długie — zawijamy zamiast ucinać.
    react_1.default.createElement("textarea", { ...shared, rows: Math.min(6, Math.ceil((cell.value.length || 1) / 30)) })) : (react_1.default.createElement("input", { ...shared, inputMode: cell.numeric ? "decimal" : undefined }))));
}
function SheetTable({ headers, widths, rows, onCashChange, onItemChange, }) {
    return (react_1.default.createElement("div", { style: { overflowX: "auto" } },
        react_1.default.createElement("table", { style: { borderCollapse: "collapse", tableLayout: "fixed" } },
            react_1.default.createElement("colgroup", null, widths.map((width, index) => (react_1.default.createElement("col", { key: index, style: { width } })))),
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, headers.map((header) => (react_1.default.createElement("th", { key: header, style: headerStyle }, header))))),
            react_1.default.createElement("tbody", null, rows.map((row, rowIndex) => (react_1.default.createElement("tr", { key: rowIndex }, row.map((cell, cellIndex) => (react_1.default.createElement(Cell, { key: cellIndex, cell: cell, onChange: (value) => {
                    if (cell.item)
                        onItemChange(cell.item.index, cell.item.field, value);
                    else if (cell.field)
                        onCashChange(cell.field, value);
                } }))))))))));
}
/**
 * Wiersz i blok w układzie arkusza — do oglądania i do wpisywania.
 *
 * To ta sama treść co formularz wyżej, tylko ułożona jak w arkuszu i podpięta pod ten
 * sam stan. Wpisanie tutaj zmienia formularz, wpisanie w formularzu zmienia to.
 *
 * Komórki szare są wyliczane — albo liczy je arkusz formułą (wydatek, suma, kolumna
 * wpływu przy karcie), albo składają się z kilku pól („kto zapłacił”). Po najechaniu
 * mówią, skąd się biorą.
 */
function SheetPreview({ input, items, onCashChange, onItemChange, }) {
    const isPostal = input.entryKind === "POSTAL";
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-3" },
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-2" },
            react_1.default.createElement("div", { className: "small text-muted mb-1" }, "Arkusz zaliczek \u2014 szare kom\u00F3rki liczy arkusz"),
            react_1.default.createElement(SheetTable, { headers: previewRows_1.CASH_HEADERS, widths: previewRows_1.CASH_WIDTHS, rows: [(0, previewRows_1.previewCashRow)(input)], onCashChange: onCashChange, onItemChange: onItemChange }),
            isPostal && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "small text-muted mt-3 mb-1" }, "Rejestr list\u00F3w \u2014 numer bloku nada arkusz"),
                react_1.default.createElement(SheetTable, { headers: previewRows_1.REGISTER_HEADERS, widths: previewRows_1.REGISTER_WIDTHS, rows: (0, previewRows_1.previewRegisterBlock)(input, items), onCashChange: onCashChange, onItemChange: onItemChange }))))));
}
